module.exports = __webpack_public_path__ + "static/media/NasaSpaceApp2022.9f1fb293.png";